import { useState, useEffect } from 'react';
import axios from 'axios';
import { useCart } from '../context/CartContext';
import TeesSubNav from '../components/TeesSubNav';
import TeesProductCard from '../components/TeesProductCard';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { SHOP_DROPDOWN, CALENDAR_DROPDOWN } from '../components/navConfig';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  { label: 'Shop', dropdown: SHOP_DROPDOWN('tees') },
  CALENDAR_DROPDOWN(''),
  { to: '/archive', label: 'Archive' },
  { to: '/about', label: 'About' },
];

const FOOTER_LINKS = [
  { to: '/about', label: 'About' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/admin/login', label: 'Admin' },
];

function TeesSale() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { itemCount, openCart } = useCart();

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/tees`, { params: { on_sale: true } });
      setProducts(response.data.filter(p => p.active));
    } catch (error) {
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="substack-site">
      {/* Header */}
      <Header navItems={NAV_ITEMS} cart={{ itemCount, onClick: openCart }} />

      <TeesSubNav />

      {/* Title */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '30px 20px 20px' }}>
        <h1 style={{
          fontFamily: "'Playfair Display', Georgia, serif",
          fontSize: '36px',
          margin: '0 0 10px',
          color: '#1a1a1a'
        }}>
          Sale
        </h1>
        <p style={{ color: '#666', fontSize: '16px', margin: 0 }}>
          {products.length > 0
            ? `${products.length} design${products.length !== 1 ? 's' : ''} on sale`
            : 'Nothing on sale right now — check back soon!'}
        </p>
      </div>

      {/* Product Grid */}
      <main style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px 20px 60px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <div className="loading-spinner" />
          </div>
        ) : products.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <p style={{ fontSize: '18px', color: '#666' }}>
              Nothing on sale right now — check back soon!
            </p>
          </div>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: '30px'
          }}>
            {products.map(product => (
              <TeesProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </main>

      {/* Footer */}
      <Footer links={FOOTER_LINKS} />
    </div>
  );
}

export default TeesSale;
